export default "__VITE_ASSET__BX_K1_D4__"